import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMobileSdkSummaryData } from 'src/apps/mobile-sdk/services/MobileSdkDashboardService';
import { REFETCH_INTERVAL } from 'src/common/consts/QueryConfigs';
import { IMobileSdkTestsFilterOption } from 'src/common/helpers/DataFilterHelper';
import { SummaryItem } from 'src/common/interfaces/SummaryItem';
import { MOBILE_SDK_SUMMARY_DATA } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useMobileSdkSummaryDataQuery = (
	filters: IMobileSdkTestsFilterOption,
	showRecentTest: boolean
): UseQueryResult<SummaryItem[]> => {
	const query = useQuery(
		[MOBILE_SDK_SUMMARY_DATA, filters, showRecentTest],
		async (): Promise<SummaryItem[]> => getMobileSdkSummaryData(filters, showRecentTest),
		{
			refetchInterval: REFETCH_INTERVAL
		}
	);

	return query;
};
